import zh_CN from './module/zh'
import en_US from './module/en'
import ru_RU from './module/ru'
import pt_BR from './module/pt'
export default {
  zh_CN,
  en_US,
  ru_RU,
  pt_BR
}